/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const personSummaryDataLastActivityActorTypeSchema = z.enum(['recruiter', 'candidate', 'system'])

export type PersonSummaryDataLastActivityActorTypeSchema = z.infer<typeof personSummaryDataLastActivityActorTypeSchema>
